export default function Reports() {
  return <h2>Reports Page</h2>;
}
